import React, { PropsWithChildren } from 'react';
import { Helmet } from 'react-helmet-async';

import { partners } from 'src/shared/constants';
import { isServer } from 'src/shared/helpers/environment';
import { useLocation, useNonce } from 'src/shared/hooks';
import { Provider } from 'src/shared/hooks/usePartner';

interface PartnerProps extends PropsWithChildren<{}> {}

const Partner = ({ children }: PartnerProps) => {
  const nonce = useNonce();
  const location = useLocation();

  const [partnerPrefix] = location.hostname.split('.');

  const partner = partners.find(
    isServer()
      ? p => p.subdomain === partnerPrefix
      : p => p.id === window.partnerId,
  );

  const bootstrap = partner ? partner.id.toString() : 'null';

  return (
    <>
      {isServer() && (
        <Helmet>
          <script nonce={nonce}>{`window.partnerId = ${bootstrap}`}</script>
        </Helmet>
      )}
      <Provider value={partner ?? null}>{children}</Provider>
    </>
  );
};

export { Partner };
